import {
  InfrastructureInstancesApi,
  InfrastructureInstancesSearchRequest,
} from 'osep-generator-service-client-v1';
import { IAS_PROJECTS_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';
import { useQuery } from '@tanstack/react-query';

function useInfraInstancesPage(
  searchRequest: InfrastructureInstancesSearchRequest,
  refetchInterval?: number,
) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [IAS_PROJECTS_QUERY_KEY, searchRequest],
    queryFn: async () => {
      const config = await getApiConfig();
      const api = new InfrastructureInstancesApi(
        config,
        undefined,
        axiosInstance,
      );

      const result = (await api.searchInfrastructureInstances(searchRequest))
        .data;

      return result;
    },
    refetchInterval,
  });
}

export default useInfraInstancesPage;
